export default "__VITE_ASSET__CIxFZPaa__"